var map = {
	"./CSSLoader": 847,
	"./CSSLoader.js": 847,
	"./ImageLoader": 848,
	"./ImageLoader.js": 848,
	"./JSBenchLoader": 849,
	"./JSBenchLoader.js": 849,
	"./JSLoader": 583,
	"./JSLoader.js": 583,
	"./JSMockLoader": 850,
	"./JSMockLoader.js": 850,
	"./JSTestLoader": 851,
	"./JSTestLoader.js": 851,
	"./ProjectConfigurationLoader": 584,
	"./ProjectConfigurationLoader.js": 584,
	"./ResourceLoader": 127,
	"./ResourceLoader.js": 127,
	"./TMPLLoader": 852,
	"./TMPLLoader.js": 852
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3352;



//////////////////
// WEBPACK FOOTER
// ./~/node-haste/lib/loader ^\.\/.*$
// module id = 3352
// module chunks = 0